// Certify ceremony for a single Criteria Checklist
// item. Wraps the generic cert confirmation modal with item-specific
// attestation language.

import { CertConfirmationModal } from "../common/CertConfirmationModal";

interface CertifyConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  itemCode: string;
  itemTitle: string;
  onConfirm: () => void | Promise<void>;
  pending?: boolean;
}

export function CertifyConfirmationModal({
  open,
  onClose,
  itemCode,
  itemTitle,
  onConfirm,
  pending,
}: CertifyConfirmationModalProps) {
  return (
    <CertConfirmationModal
      open={open}
      onClose={onClose}
      title={`Certify ${itemCode}`}
      attestationText={`Mark ${itemCode} — ${itemTitle} — as Approved?\n\nYou attest that you have reviewed all evidence (form data, attached reports, BLA references) and the item is satisfied for this deal.\n\nThis ceremony is permanent and recorded in the audit log.`}
      confirmLabel="Certify item"
      onConfirm={onConfirm}
      pending={pending}
    />
  );
}
